import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const CALENDLY_URL = 'https://calendly.com/klassi-chat/15min';

const CalendlyFab = () => {
  const [show, setShow] = useState(false);

  const embedUrl = `${CALENDLY_URL}?hide_gdpr_banner=1&embed_type=Inline&embed_domain=${window.location.hostname}`;

  return (
    <>
      <button
        type="button"
        onClick={() => setShow(true)}
        className="position-fixed bottom-0 end-0 m-4 btn btn-primary rounded-circle p-3 shadow"
        style={{ zIndex: 1000 }}
        aria-label="Schedule a meeting"
      >
        <i className="bi bi-calendar-check fs-4"></i>
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        centered
        fullscreen="md-down"
      >
        <Modal.Header closeButton closeVariant="white" className="bg-primary text-white">
          <Modal.Title>Schedule a Chat</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {show && (
            <iframe
              src={embedUrl}
              title="Schedule with Klassi"
              width="100%"
              height="650"
              frameBorder="0"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CalendlyFab;
